/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './dfp-advert-unit.stache';
import can from 'can';
import _ from 'lodash';
import appConfig from 'scripts/app-config';

const screenSizes = appConfig['screen-sizes'];
const INITIAL_AD_TRY_FETCH_COUNT = 3;
const INITIAL_AD_TRY_FETCH_INTERVAL = 1000;
const TIME_FOR_AD_REQUEST = 3000;

export const adsMap = new Map();

Component.extend({
    tag: 'dfp-advert-unit',
    template: template,
    leakScope: false,
    viewModel: {
        optDiv: null,
        define: {
            adUnitPath: {
                type: 'string',
            },
            reloadInterval: {
                type: 'number',
            },
            sizes: {
                Type: can.List,
                Value: can.List,
            },
            responsive: {
                type: 'boolean',
            },
        },
    },
    events: {
        inserted($element) {
            const adUnitPath = this.viewModel.attr('adUnitPath');
            if (!adUnitPath) {
                console.error('Ad unit path not defined.');
                return;
            }

            if (adsMap.get(adUnitPath)) {
                return;
            }

            const optDiv = _.uniqueId('div-gpt-ad-');
            let sizes = [];
            this.viewModel.attr('optDiv', optDiv);
            this.viewModel
                .attr('sizes')
                .each((size) => sizes.push([size.width, size.height]));
            let googletag = this.getGoogletag();
            googletag.cmd = googletag.cmd || [];
            googletag.cmd.push(() => {
                let slot = googletag.defineSlot(adUnitPath, sizes, optDiv);
                if (sizes.length > 1 && this.viewModel.responsive) {
                    const sizeMapping = this.createSizeMapping(sizes);
                    slot.defineSizeMapping(sizeMapping);
                }
                if (slot) {
                    this.fetchCount = 0;
                    slot.addService(googletag.pubads());
                    googletag.pubads().enableSingleRequest();
                    googletag
                        .pubads()
                        .addEventListener('slotRenderEnded', (event) => {
                            const eventAdUnitPath = event.slot.getAdUnitPath();

                            if (eventAdUnitPath !== adUnitPath) {
                                return;
                            }

                            this.fetchCount++;
                            const container = $(`#${optDiv}`);
                            const defaultHeight = container
                                .find('iframe')
                                .height();
                            const height =
                                (event.size && event.size[1]) || defaultHeight;
                            let adIsBlocked = false;
                            if (this.blockTimeout) {
                                clearTimeout(this.blockTimeout);
                            }

                            const iframes = container
                                .find('iframe')
                                .parentsUntil(container)
                                .addBack()
                                .add(container);

                            if (iframes.length > 0) {
                                adIsBlocked = true;
                                iframes.each((index, element) => {
                                    const style = window.getComputedStyle(
                                        element,
                                    );

                                    if (style) {
                                        const visibility = style.getPropertyValue(
                                            'visibility',
                                        );
                                        const display = style.getPropertyValue(
                                            'display',
                                        );
                                        adIsBlocked =
                                            adIsBlocked &&
                                            (visibility === 'hidden' ||
                                                display === 'none');
                                    } else {
                                        adIsBlocked = false;
                                    }
                                });
                            }

                            const emptyResponse =
                                event.isEmpty &&
                                container.find('iframe').length === 0;

                            if (
                                emptyResponse &&
                                this.fetchCount <= INITIAL_AD_TRY_FETCH_COUNT
                            ) {
                                setTimeout(() => {
                                    googletag.pubads().refresh();
                                }, INITIAL_AD_TRY_FETCH_INTERVAL);
                            } else if (adIsBlocked || emptyResponse) {
                                this.viewModel.dispatch('didnotrender');
                            }

                            if (height) {
                                container.height(height);
                            }
                        });
                    googletag.enableServices();
                } else {
                    this.viewModel.dispatch('didnotrender');
                    console.error('Ad configuration error.');
                }
            });
            googletag.cmd.push(function() {
                googletag.display(optDiv);
            });
            adsMap.set(adUnitPath, true);
            let reloadInterval = +this.viewModel.attr('reloadInterval');

            if (reloadInterval && !googletag.reloader) {
                googletag.reloader = setInterval(() => {
                    if (googletag.pubads) {
                        googletag.pubads().refresh();
                    }
                }, reloadInterval * 1000);
            }
            //check if adBlock don't allow request
            this.blockTimeout = setTimeout(() => {
                this.viewModel.dispatch('didnotrender');
            }, TIME_FOR_AD_REQUEST);
        },
        removed() {
            let googletag = (window.googletag = window.googletag || {});
            if (googletag.reloader) {
                clearInterval(googletag.reloader);
                googletag.reloader = null;
            }
        },

        getGoogletag() {
            return (window.googletag = window.googletag || {});
        },

        createSizeMapping(sizes) {
            const googletag = this.getGoogletag();
            const sizeMappingBuilder = googletag.sizeMapping();
            const screenSizeNames = ['large', 'medium', 'small'];

            sizes.sort((a, b) => b[0] - a[0]);

            while (sizes.length > 1 && screenSizeNames.length > 0) {
                const size = sizes.shift();
                const screenSizeName = screenSizeNames.shift();
                sizeMappingBuilder.addSize(
                    [screenSizes[screenSizeName].min, 0],
                    size,
                );
            }
            sizeMappingBuilder.addSize([0, 0], sizes);

            return sizeMappingBuilder.build();
        },
    },
});
